import React, { memo } from "react";
import "./InfoBanner.scss";

/*
 * The full-width contextual banners used around the pay request form: the blue
 * "showing dates for ..." notice, the tappable "apply to all" prompt, the grey
 * estimate disclaimer and the amber negative-balance warning.
 *
 * `attach` squares off the corners on the side the banner tucks against a card
 * so the two read as one surface.
 */
const InfoBanner = ({
  text,
  children,
  variant = "info",
  onClick,
  attach = "none",
  className = "",
}) => {
  const classNames = [
    "info-banner",
    `info-banner--${variant}`,
    attach !== "none" && `info-banner--attach-${attach}`,
    onClick && "info-banner--clickable",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = children ?? text;

  if (onClick) {
    return (
      <button type="button" className={classNames} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className={classNames}>{content}</div>;
};

export default memo(InfoBanner);
